function initWishlist() {
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const wishListButtons = document.querySelectorAll(".wishlist-button-collection");

  function updateButtonState(button, productId, isInWishlist) {
    if (isInWishlist) {
      button.classList.add("added-to-wishlist");
    } else {
      button.classList.remove("added-to-wishlist");
    }
  }

  wishListButtons.forEach((button) => {
    const productId = button.dataset.productId;
    if (!productId) {
      console.error("Missing productId for button:", button);
      return;
    }

    const isInWishlist = wishlist.includes(productId);
    updateButtonState(button, productId, isInWishlist);

    button.replaceWith(button.cloneNode(true));
    const newButton = document.querySelector(`[data-product-id="${productId}"]`);

    newButton.addEventListener("click", function (event) {
      event.preventDefault();

      const index = wishlist.indexOf(productId);
      if (index === -1) {
        wishlist.push(productId);
      } else {
        wishlist.splice(index, 1);
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      updateButtonState(newButton, productId, index === -1);
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(initWishlist, 1000);
});

setInterval(() => {
  initWishlist();
}, 4000);
